import React, { useState, useEffect } from 'react';
import { getApiHost } from '../../../server/services/custom-pages/apiHost';
import styles from './WorldCupArticles.module.css';
import OptimizedImage from '../player/OptimizedImage';

function ArticleCard({ img, category, title, date, url }) {
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.articleCard}
      style={{ textDecoration: 'none' }}
    >
      <OptimizedImage
        src={img}
        alt={title}
        width={400}
        height={250}
        unoptimized
        className={styles.articleImage}
      />
      <div className={styles.articleContent}>
        <div className={styles.articleInnerText}>
          <span className={styles.articleCategory}>{category}</span>
          <h3 className={styles.articleTitle}>{title}</h3>
        </div>
        <span className={styles.articleDate}>{date}</span>
      </div>
    </a>
  );
}

export default function WorldCupArticles({ initialArticles = [] }) {
  const [articles, setArticles] = useState(initialArticles);
  const [loading, setLoading] = useState(initialArticles.length === 0);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (articles.length > 0) return;
    const loadArticles = async () => {
      try {
        const tagQuery = encodeURIComponent('worldcup 2026');
        const apiPrefix = typeof window !== "undefined" && window.qtMountAt ? window.qtMountAt : "";
        const res = await fetch(`${apiPrefix}/api/v1/advanced-search?tag-name-lower=${tagQuery}&sort=latest-published`);
        const data = await res.json();
        const mapped = (data.items || []).map(story => {
          const imageKey = story['hero-image-s3-key'];
          return {
            id: story.id,
            headline: story.headline,
            date: new Date(story['last-published-at']).toLocaleDateString('en-GB', { day: '2-digit', month: 'long', year: 'numeric' }),
            category: story.sections?.[0]?.name,
            thumbnail: imageKey ? `https://media.assettype.com/${imageKey}?auto=format&fit=crop&w=900&q=80` : null,
            url: story.url,
          };
        });
        setArticles(mapped);
      } catch (err) {
        setError('Failed to load articles');
      } finally {
        setLoading(false);
      }
    };
    loadArticles();
  }, []);

  if (loading) {
    return (
      <div className={styles.sectionContainer}>
        <h2 className={styles.articlesSectionHeading}>Latest News</h2>
        <div className={styles.fullDivider} />
        <p className={styles.statusMsg}>Loading articles...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles.sectionContainer}>
        <h2 className={styles.articlesSectionHeading}>Latest News</h2>
        <div className={styles.fullDivider} />
        <p className={styles.statusMsg}>{error}</p>
      </div>
    );
  }

  if (articles.length === 0) {
    return (
      <div className={styles.sectionContainer}>
        <h2 className={styles.articlesSectionHeading}>Latest News</h2>
        <div className={styles.fullDivider} />
        <p className={styles.statusMsg}>No articles available</p>
      </div>
    );
  }
  return (
    <div className={styles.articlesSectionContainer}>
      <h2 className={styles.articlesSectionHeading}>
        Articles
      </h2>
      <div className={styles.articlesGrid}>
        {articles.map((article) => (
          <ArticleCard
            key={article.id}
            img={article.thumbnail}
            category={article.category}
            title={article.headline}
            date={article.date}
            url={article.url}
          />
        ))}
      </div>
    </div>
  );
}
